import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

export enum ToastType {
  Error = 'toast-error',
  Success = 'toast-success',
  Warning = 'toast-warning'
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly _matSnackBarHorizontalPosition: MatSnackBarHorizontalPosition = 'center';
  private readonly _matSnackBarVerticalPosition: MatSnackBarVerticalPosition = 'top';

  public constructor(
    private readonly _snackbar: MatSnackBar,
  ) { }

  public raiseMessage(content: string, toastType: ToastType): void {
    this._snackbar.open(
      content,
      'OK',
      {
        duration: 5000,
        horizontalPosition: this._matSnackBarHorizontalPosition,
        verticalPosition: this._matSnackBarVerticalPosition,
        panelClass: toastType,
      },
    );
  }
}
